// Design v2 feature flag ("Booth" look + hero pages). Device-scoped like the
// theme: persisted in localStorage, mirrored in settings.designV2, exposed to
// CSS as [data-design="v2"] on <html>. Every v2 rule in the stylesheets is
// scoped under that attribute so the old design is untouched when it is off.
import { useSelector } from 'react-redux';

export const DESIGN_V2_KEY = 'mixgoat-design-v2';

// Available everywhere: desktop, the web app and Capacitor native. The phone
// layout lives in styles/design-v2/_mobile.scss (scoped to .App.is-mobile-web).
export const DESIGN_V2_AVAILABLE = true;

// On by default since 2026-10-26: only an explicit switch-off ('0') keeps the
// classic design.
export function readDesignV2() {
    if (!DESIGN_V2_AVAILABLE) return false;
    try { return localStorage.getItem(DESIGN_V2_KEY) !== '0'; } catch (e) { return true; }
}

export function applyDesignV2(on) {
    if (typeof document === 'undefined') return;
    if (!DESIGN_V2_AVAILABLE) on = false;
    const root = document.documentElement;
    if (on) {
        root.setAttribute('data-design', 'v2');
        // The dark texture is injected inline by applyTheme; v2 is flat.
        root.style.removeProperty('--color-panel-bg');
        root.style.removeProperty('--color-player-bg');
    } else {
        root.removeAttribute('data-design');
    }
    // v2 is tuned at 1:1 CSS px; the classic design at a 1.095 baseline. Main owns the zoom.
    try { window.electron?.zoom?.setDesignV2?.(!!on); } catch (e) { /* web */ }
    try {
        if (!DESIGN_V2_AVAILABLE) localStorage.removeItem(DESIGN_V2_KEY);
        else localStorage.setItem(DESIGN_V2_KEY, on ? '1' : '0');
    } catch (e) { /* ignore */ }
}

// Hook for components that change STRUCTURE under v2 (hero headers, tool
// header, tab strips). Pure restyles should use CSS under [data-design="v2"]
// instead of branching in JSX.
export function useDesignV2() {
    return useSelector((s) => DESIGN_V2_AVAILABLE && !!s.settings?.designV2);
}
